import React from "react";
import { Form, Radio } from "antd";
import moment, { Moment } from "moment";
import TimeType from "@/scenes/OrderManagement/enum/TimeType";
import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";
import { observer } from "mobx-react-lite";
import BaseDatePicker from "@/components/BaseDatePicker";
import TableSearchState from "@/scenes/OrderManagement/redux/states/TableSearchState";
import QuickTimeField from "./QuickTimeField";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import "./TimeRangePicker.less";

interface TimeRangePickerProps {
    shop?: ShopDTO;
}

const TimeRangePicker: React.FC<TimeRangePickerProps> = ({ shop }) => {
    const orderManagementStore = useOrderManagementStore();

    function handleChange() {
        orderManagementStore.table.form.setFieldsValue({ quickTimeSelectConfigId: null });
    }

    return (
        <div className="ml10" style={{ display: "flex", alignItems: "center" }}>
            <Form.Item<TableSearchState> noStyle shouldUpdate>
                {(form) => {
                    const { timeTo, timeFrom } = form.getFieldsValue();

                    const disabledStartDate = (value: Moment) => {
                        if (!value || !timeTo) {
                            return false;
                        }

                        return value.isAfter(moment(timeTo));
                    };

                    const disabledEndDate = (current: Moment) => {
                        if (!current || !timeFrom) {
                            return false;
                        }

                        const value =
                            current.date() === moment(timeFrom).date()
                                ? moment(current).hours(24).minutes(0).seconds(0).milliseconds(0)
                                : current;

                        return value.isSameOrBefore(moment(timeFrom));
                    };

                    return (
                        <>
                            <Form.Item
                                name="timeType"
                                initialValue={TimeType.ORDER}
                                className="inline-block"
                                style={{ marginRight: 0 }}
                            >
                                <Radio.Group className="order-search-time-type-group">
                                    <Radio value={TimeType.ORDER} style={{ marginRight: 0 }}>
                                        <span style={{ fontSize: 13 }}>下单时间</span>
                                    </Radio>
                                    {shop?.type !== ShopType.PDD_FDS && (
                                        <Radio value={TimeType.PAY} style={{ marginRight: 0 }}>
                                            <span style={{ fontSize: 13 }}>付款时间</span>
                                        </Radio>
                                    )}
                                    <Radio value={TimeType.PRINT} style={{ marginRight: 0 }}>
                                        <span style={{ fontSize: 13 }}>打印时间</span>
                                    </Radio>
                                    <Radio value={TimeType.SHIP} style={{ marginRight: 0 }}>
                                        <span style={{ fontSize: 13 }}>发货时间</span>
                                    </Radio>
                                </Radio.Group>
                            </Form.Item>

                            <QuickTimeField />

                            <Form.Item name="timeFrom" className="inline-block" style={{ marginRight: 0 }}>
                                <BaseDatePicker
                                    className="date-picker"
                                    showTime={{
                                        defaultOpenValue: moment("00:00:00", "HH:mm:ss"),
                                        showHour: true,
                                        showMinute: true,
                                        showSecond: true,
                                    }}
                                    format="YYYY-MM-DD HH:mm:ss"
                                    size="small"
                                    placeholder="起始时间"
                                    allowClear
                                    suffixIcon={<></>}
                                    autoComplete="off"
                                    disabledDate={disabledStartDate}
                                    onChange={handleChange}
                                />
                            </Form.Item>

                            <span className="to-label">至</span>

                            <Form.Item name="timeTo" className="inline-block">
                                <BaseDatePicker
                                    className="date-picker"
                                    name="timeTo"
                                    showTime={{
                                        defaultOpenValue: moment("23:59:59", "HH:mm:ss"),
                                        showHour: true,
                                        showMinute: true,
                                        showSecond: true,
                                    }}
                                    format="YYYY-MM-DD HH:mm:ss"
                                    size="small"
                                    placeholder="结束时间"
                                    allowClear
                                    suffixIcon={<></>}
                                    autoComplete="off"
                                    disabledDate={disabledEndDate}
                                    onChange={handleChange}
                                />
                            </Form.Item>
                        </>
                    );
                }}
            </Form.Item>
        </div>
    );
};

export default observer(TimeRangePicker);
